import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ValueDisplayDirective } from '@change-requests/directives/value-display.directive';
import { DisplayComponentInterface } from '@change-requests/interfaces/display-component.interface';
import { DisplayComponentsService } from '@change-requests/services';
import { FieldValue } from '@change-requests/types/field.value.type';

@Component({
    selector: 'field-value-display-component',
    template: `
        <div>
            <ng-template valueDisplay></ng-template>
        </div>
    `,
})
export class FieldValueDisplayComponent implements OnInit {
    @Input() value: FieldValue = '';
    @Input() fieldKey = '';
    @ViewChild(ValueDisplayDirective, { static: true }) valueDisplay!: ValueDisplayDirective;

    constructor(private displayComponentsService: DisplayComponentsService) {}

    ngOnInit(): void {
        const displayComponent = this.displayComponentsService.getComponentClass(this.fieldKey);

        if (!displayComponent) {
            console.warn(`No display component defined or configuration is missing for field: ${this.fieldKey}`);
            // Clear the view container and return
            const viewContainerRef = this.valueDisplay.viewContainerRef;
            viewContainerRef.clear();
            // Display the raw value as a fallback
            const textNode = document.createTextNode(String(this.value || '-'));
            viewContainerRef.element.nativeElement.appendChild(textNode);
            return;
        }

        const viewContainerRef = this.valueDisplay.viewContainerRef;
        viewContainerRef.clear();

        const componentRef = viewContainerRef.createComponent<DisplayComponentInterface>(displayComponent);
        componentRef.instance.value = this.value;
    }
}
